import React, { useCallback, useState } from 'react'

import PropTypes from 'prop-types'

import { Container, Results, ResultsFooter } from './styles'
import { FiSearch } from 'react-icons/fi'
import { debounce } from '@shared/utils/debounce'
import InputBase from '../Input/InputBase'
import { InnerLoading } from '@shared/components/Layout/_InnerLoading'

const Search = ({ onSearch, isLoading, children, renderFooter: Footer, className, ...props }) => {
  const [isResultsVisible, setIsResultsVisible] = useState(false)

  const handleInputSearch = debounce(
    (event) => onSearch(event.target.value)
  )

  const handleInputFocus = useCallback(
    () => {
      setIsResultsVisible(true)
    }, []
  )

  const handleInputBlur = useCallback(
    () => {
      // wait 200ms before hide results to prevent that any internal event not get fired
      setTimeout(() => { setIsResultsVisible(false) }, 250)
    }, []
  )

  return (
    <Container data-testid="search-container" className={className}>
      <InputBase
        data-testid="search-input"
        rightIcon={FiSearch}
        onChange={handleInputSearch}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        autoComplete="off"
        {...props}
      />

      <Results
        data-testid="search-results"
        className="scrollarea"
        isVisible={isResultsVisible}
      >
        <InnerLoading active={isLoading}>
          {isResultsVisible && children}

          {Footer && (
            <ResultsFooter>
              <Footer />
            </ResultsFooter>
          )}
        </InnerLoading>
      </Results>
    </Container>
  )
}

Search.displayName = 'Search'

Search.defaultProps = {
  isLoading: false
}

Search.propTypes = {
  onSearch: PropTypes.func,
  children: PropTypes.any,
  className: PropTypes.any,
  isLoading: PropTypes.bool,
  renderFooter: PropTypes.elementType
}

export default Search
